import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-table-card-display',
  templateUrl: './table-card-display.component.html',
  styleUrls: ['./table-card-display.component.scss'],
})
export class TableCardDisplayComponent {
  @Input() set tableData(val: any[]) {
    this.dataSource = val;
  }
  dataSource: any[] = [];
  @Output() showDetails = new EventEmitter<any>();

  onShowDetails(val: any) {
    this.showDetails.emit(val);
  }
}
